// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/checkbox/index.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Indeterminate } from './Indeterminate.story';
import { Primary } from './Primary.story';
import { Invalid } from './Invalid.story';
import { Disabled } from './Disabled.story';
import { Controlled } from './Controlled.story';
import { Uncontrolled } from './Uncontrolled.story';
const basic = {
  rendered: <Primary />,
  source: `<Checkbox
  label="This is a Checkbox."
  onChange={(e) => {
    console.log(e.target.checked);
  }}
/>`
};
const controlled = {
  rendered: <Controlled />,
  source: `const [checked, setChecked] = React.useState(false);
  
return (
  <Checkbox
    onChange={() => {
      setChecked(!checked);
    }}
    checked={checked}
    label="This Checkbox is controlled."
  />
);`
};
const uncontrolled = {
  rendered: <Uncontrolled />,
  source: `<Checkbox
  onChange={(e) => {
    console.log(e.target.checked);
  }}
  defaultChecked
  label="This Checkbox is uncontrolled."
/>`
};
const disabled = {
  rendered: <Disabled />,
  source: `const [checked, setChecked] = React.useState(false);
  
return (
  <Box css={{layout: 'column'}}>
    <Checkbox
      label="This uncontrolled Checkbox is disabled."
      defaultChecked
      disabled
    />
    <Checkbox
      onChange={() => {
        setChecked(!checked);
      }}
      checked={checked}
      disabled
      label="This controlled Checkbox is disabled."
    />
    <Checkbox
      disabled
      invalid
      defaultChecked
      label="This uncontrolled, invalid Checkbox is disabled."
    />
  </Box>
);`
};
const invalid = {
  rendered: <Invalid />,
  source: `<Checkbox label="This Checkbox is in an invalid state." invalid />`
};
const indeterminate = {
  rendered: <Indeterminate />,
  source: `const [checked1, setChecked1] = React.useState(false);
const [checked2, setChecked2] = React.useState(false);

return (
  <Box
    css={{
      layout: 'column',
    }}
  >
    <Checkbox
      label="This Checkbox is aggregating the state of the Checkboxes below it."
      checked={checked1 && checked2}
      readOnly
      indeterminate={checked1 !== checked2}
    />
    <Checkbox
      label="Checkbox 1"
      checked={checked1}
      onChange={() => {
        setChecked1(!checked1);
      }}
    />
    <Checkbox
      label="Checkbox 2"
      checked={checked2}
      onChange={() => {
        setChecked2(!checked2);
      }}
    />
  </Box>
);`
};
export const CheckboxExamples = {
  basic,
  controlled,
  uncontrolled,
  disabled,
  invalid,
  indeterminate
};